"use client";

/**
 * lib/client-error-report.ts — one place that posts error-boundary catches to
 * /api/alerts/client-error (→ #tsb-errors).
 *
 * Every error.tsx boundary used to inline this fetch with a message-only
 * payload, which made alerts untriageable: the 2026-07-13 "network error"
 * incident arrived as two words with no name, no stack and no browser, and the
 * string existed nowhere in our code or dependencies. Boundaries now share
 * this helper so alerts carry error.name + the top of the stack (the server
 * route adds the user-agent from the request), and enriching the payload again
 * later is a one-file change.
 *
 * Fire-and-forget: alerting must never break the error UI that's rendering.
 */

/** Cap on the stack sent over the wire — the top frames identify the thrower. */
const STACK_CHAR_LIMIT = 1200;

export function reportClientError(route: string, error: unknown): void {
  const err = error instanceof Error ? error : null;
  fetch("/api/alerts/client-error", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      route,
      message: err?.message || "Unknown render error",
      digest: (err as (Error & { digest?: string }) | null)?.digest,
      name: err?.name,
      stack: err?.stack?.slice(0, STACK_CHAR_LIMIT),
    }),
  }).catch((e) => console.error("[client-error alert] failed:", e));
}
